import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';

class UpdateSection extends Component {
	
	constructor(props){
		super(props);
		this.state = {
			id : '',
			acyear : '',
			cls : '',
			section : '',
			secstatus : '',
			_message : '',
			alertClass :'',
			posts : [],
			secs : [],
			accyear : []
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.back = this.back.bind(this);
	}
	
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
	}
	
	onSubmit(e){
		e.preventDefault();
		
		if(this.state.acyear && this.state.cls && this.state.section && this.state.secstatus){
			
			PostData('section/edit',this.state).then((result) => {
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Section Updated Successfully!..',
						alertClass:'alert alert-success',
					});
					document.getElementById("subform").reset();
				}
				else{
			
					this.setState({
						_message:'Invalid Key',
						alertClass:'alert alert-danger'
					});
				}
			});
		
		}
	
	}
	
	componentWillMount(){
		
		this.getclass();
		this.getsection();
		this.getacyear();
		this.getdetails();
	}
	
	getclass(){
		
		GetData('classs/getclass').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
	getsection(){
		
		GetData('section/getsection').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					secs : responseJson
				});
			}
		});
	}
	
	getacyear(){
		
		GetData('academic/getacyear').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					accyear : responseJson
				});
			}
		});
	}
	
	getdetails(){
		
		GetData('section/getacsectionbyid/'+this.props.match.params.id).then((result) => {
			let res = result;
			if(res){
				this.setState({
					acyear : res[0]['acyear'],
					cls : res[0]['class'],
					section : res[0]['section'],
					secstatus : res[0]['secstatus']
				});
			}
		});
	}
	
	/** redirect to Section **/
	back(e){
		
		this.setState({_redirect :true});
	}
	
  render() {
	 
	this.state.id = this.props.match.params.id;
	
	if(this.state._redirect){
		  
		return (<Redirect to='/academic/addsection' />);
	}
	
	/** set status select box **/
	this.acyearstatus = [
		{value : '', name : 'Select'},
		{value : 'Active', name : 'Active'},
		{value : 'Deactive', name : 'Deactive'}
	];
	
	var items = this.state.posts;
	var sec = this.state.secs;
	var acyear = this.state.accyear;
	
    return (
		<div className="animated fadeIn">
		  <div className={this.state.alertClass}>
			{this.state._message}
		  </div>
			<Row>
			  <Col md="12">
				<Card>
				  <form action="" method="post" role="form" id="subform" encType="multipart/form-data" onSubmit={this.onSubmit} >
					<CardHeader>
						<strong>Edit Section</strong>
						<span className="pull-right">
							<Button outline color="primary" onClick={this.back}>Back</Button>
						</span>
					</CardHeader>
					<CardBody>
						<Row>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Academic Year <span className="text-danger">*</span></Label>
							  <select name="acyear" className="form-control" onChange={this.onChange} required value={this.state.acyear} >
								<option value="">Select</option>
								{
									acyear.map(function (item) {
										return <option value={item.id }>{item.value}</option>;
									})
								}
							  </select>
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Class <span className="text-danger">*</span></Label>
							  <select name="cls" className="form-control" onChange={this.onChange} required value={this.state.cls} >
								<option value="">Select Class</option>
								{
									items.map(function (item) {
										return <option value={item.id }>{item.class}</option>;
									})
								}
							  </select>
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Section <span className="text-danger">*</span></Label>
							  <select name="section" className="form-control" onChange={this.onChange} required value={this.state.section} >
								<option value="">Select Section</option>
								{
									sec.map(function (item) {
										return <option value={item.id }>{item.section}</option>;
									})
								}
							  </select>
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Active / Deactive <span className="text-danger">*</span></Label>
							  <select name="secstatus" className="form-control" onChange={this.onChange} required value={this.state.secstatus} >
								{this.acyearstatus.map((e, key) => {
									return <option key={key} value={e.value}>{e.name}</option>;
								})}	
							 </select>
							</FormGroup>
						  </Col>
						</Row>
					</CardBody>
					<CardFooter>
						<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Update</Button>
					</CardFooter>
				  </form>
				</Card>
			  </Col>
			</Row>
		</div>
	);
  }
}

export default UpdateSection;


// WEBPACK FOOTER //
// ./src/academic/AddSection/UpdateSection.js